import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { SOTService } from '../../services';
import { Subscription } from 'rxjs';
import { ProcessCard } from '../../models';

@Component({
  selector: "sot-cardscan",
  templateUrl: "./cardscan.component.html",
  styleUrls: ["./cardscan.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardscanComponent implements OnInit, OnDestroy {

  private last_card: ProcessCard;
  public isModeOne: boolean = false;
  public isModeTwo: boolean = false;
  private scanCardSubscription: Subscription;

  public get has_logo_image(): boolean {
    return this._sotService.GetSettings().has_logo_image;
  }

  public get logo_image_path(): string {
    return this._sotService.GetSettings().logo_image_path;
  }

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _sotService: SOTService) {
  }

  public ngOnInit(): void {
    const me = this;
    me.isModeOne = me._sotService.useModeOne();
    me.isModeTwo = me._sotService.useModeTwo();
    me.last_card = me._sotService.currentCard;
    me.scanCardSubscription = me._sotService.evScanCardDone.subscribe((success) => {
      if (success) {
        const currentCard = me._sotService.currentCard;
        if (currentCard.no !== me.last_card.no) {
          me._sotService.OpenWrongCardDialog();
        } else {
          me._sotService.TryCardPayment();
        }
      } else {
        me._sotService.OpenCardCouldNotBeReadDialog(() => {
          me._sotService.SOTConnectionSendScanCard();
        });
      }
    });
    me._sotService.SOTConnectionSendScanCard();
  }

  public ngOnDestroy(): void {
    const me = this;
    if (me.scanCardSubscription) {
      me.scanCardSubscription.unsubscribe();
    }
  }

  public back(): void {
    const me = this;
    me._sotService.SOTConnectionSendCancelScanning();
    if (me._sotService.GetSettings().use_pager) {
      me._sotService.GoToPager();
    } else {
      me._sotService.GoToCheckout();
    }
  }
}
